import React from "react";

const BUBBLE_RIGHT_CLASSNAMES = `
  relative inline-block max-w-[400px] rounded-[14px] border border-gray-200 bg-white px-3 py-2 text-gray-900
  leading-relaxed shadow-sm
  before:absolute before:right-[-8px] before:top-[12px] before:h-0 before:w-0
  before:border-y-[8px] before:border-l-[8px] before:border-r-0 before:border-y-transparent before:border-l-gray-200
  after:absolute after:right-[-7px] after:top-[12px] after:h-0 after:w-0
  after:border-y-[8px] after:border-l-[8px] after:border-r-0 after:border-y-transparent after:border-l-white
`;

interface RightChatBubbleViewProps {
  children: React.ReactNode;
}

export const RightChatBubbleView = ({ children }: RightChatBubbleViewProps) => (
  <div className={BUBBLE_RIGHT_CLASSNAMES}>
    {children}
  </div>
);
